import * as types from './mutation-types'


export default {
  [types.LOAD_USERS_GROUPS](state, data) {
    state.usersGroups = data.data;
  },

  [types.ADD_USER_GROUP](state, data) {
    state.usersGroups.push(data);
  },

  [types.UPDATE_USER_GROUP](state, data) {
    const index = state.usersGroups.findIndex(group => group.id === data.id);
    if (index !== -1) {
      state.usersGroups.splice(index, 1, data);
    }
  },

  [types.DELETE_USER_GROUP](state, id) {
    state.usersGroups = state.usersGroups.filter(group => group.id !== id);
  },
};

